import React, { Component, ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
  resetKey?: string;
  visibleFeedback: boolean;
  setVisibleFeedback: (v: boolean) => void;
  setErrorLog: (log: Record<string, unknown>) => void;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
  errorInfo?: React.ErrorInfo;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(previousProps: ErrorBoundaryProps) {
    if (
      this.state.hasError &&
      previousProps.resetKey !== this.props.resetKey
    ) {
      this.setState({ hasError: false, error: undefined, errorInfo: undefined });
    }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.groupCollapsed("Erreur React (ErrorBoundary)");
    console.error("Error:", error);
    console.error("Name:", error?.name);
    console.error("Message:", error?.message);
    console.error("Stack:", error?.stack);
    console.error("Component stack:", errorInfo?.componentStack);
    console.groupEnd();

    // Stocker le log dans le store
    this.props.setErrorLog({
      message: error?.message,
      name: error?.name,
      stack: error?.stack,
      componentStack: errorInfo?.componentStack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      time: new Date().toISOString(),
    });

    // AJOUT : Ouvrir le modal automatiquement
    // this.props.setVisibleFeedback(true);
  }

  render() {
    const { setVisibleFeedback } = this.props;

    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center pt-20 text-center">
          <h1 className="text-4xl font-bold text-red-600">Oups !</h1>
          <p className="mt-4 text-lg">Une erreur s&apos;est produite.</p>
          <p className="mt-2 text-gray-600">Veuillez réessayer plus tard.</p>
          <div className="flex flex-row gap-4 items-center">
            <button
              onClick={() => window.location.reload()}
              className="mt-6 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
            >
              Réessayer
            </button>
            <button
              onClick={() => {
                console.log(
                  "Ouverture du modal de feedback depuis ErrorBoundary",
                );
                setVisibleFeedback(true);
              }}
              className="mt-6 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
            >
              Signaler le problème
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
